import { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";
import { getCategoryFromId } from "lib/utils";

const editCellRenderer = (params) => {
  return <Link to={`/admin/products/${params.data.id}`}>Edit</Link>;
};

const deleteCellRenderer = (params) => {
  return (
    <Button
      onClick={() => {
        if (window.confirm("Are you sure you want to delete this product?")) {
          params.data.handleDeleteProduct(params.data.id);
        }
      }}
    >
      Delete
    </Button>
  );
};

const categoriesValueGetter = (params) => {
  return params.data.categories.map((category) => category.name).join(", ");
};

const columns = [
  {
    field: "sku",
    headerName: "SKU",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "name",
    headerName: "Name",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "type",
    headerName: "Type",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "description",
    headerName: "Description",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "price",
    headerName: "Price",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "categories",
    headerName: "Categories",
    resizable: true,
    filter: "agTextColumnFilter",
    valueGetter: categoriesValueGetter
  },
  {
    field: "availability",
    headerName: "Availability",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "weight",
    headerName: "Weight",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "edit",
    headerName: "Edit",
    resizable: true,
    filter: "agTextColumnFilter",
    cellRendererFramework: editCellRenderer,
  },
  {
    field: "delete",
    headerName: "Delete",
    resizable: true,
    filter: "agTextColumnFilter",
    cellClass: "action",
    minWidth: 120,
    cellRendererFramework: deleteCellRenderer,
  },
];

function Products() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const handleDeleteProduct = async (productId) => {
    try {
      const response = await axios.delete(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/bc/products/${productId}`
      );
      if (response.status === 200) {
        window.location.reload(true);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/bc/products?sort=id&direction=desc&limit=300`
      );
      if (response.status === 200) {
        const products = response.data.products;
        for (const product of products) {
          product.handleDeleteProduct = handleDeleteProduct;
        }
        setProducts(products);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getCategories = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/bc/categories`
      );
      if (response.status === 200) {
        const categories = response.data.categories;
        setCategories(categories);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    getProducts(); // eslint-disable-next-line react-hooks/exhaustive-deps
    getCategories(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (categories.length > 0) {
      for (const product of products) {
        // Converting array of categories ids into an array of categories objects.
        product.categories = product.categories.map((categoryId) =>
          getCategoryFromId(categoryId, categories)
        );
        setProducts(products);
      }
    }
  }, [categories, products]);

  const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
  };

  return (
    <div style={{ padding: "40px" }}>
      <Row>
        <Col xs={{ span: 6 }}>
          <h1 style={{ marginBottom: "30px" }}>Products</h1>
        </Col>
        <Col xs={{ span: 2, offset: 4 }}>
          <Link to={"/admin/products/new"}>
            <Button>Add Product</Button>
          </Link>
        </Col>
      </Row>
      <div
        className="ag-theme-alpine"
        style={{
          height: "500px",
          width: "100%",
        }}
      >
        <AgGridReact
          defaultColDef={{
            filter: true,
            minWidth: 170,
          }}
          floatingFilter={true}
          columnDefs={columns}
          rowData={products}
          onGridReady={onGridReady}
          rowHeight={42}
        />
      </div>
    </div>
  );
}
export default Products;
